/* ========================== */
/* ========= import ========= */
/* ========================== */

/* ====== React ====== */
import React from "react"

/* ====== CSS ====== */
import styled from 'styled-components';

/* ====== Component Js/Jsx ====== */
import { ButtonBack, ButtonEdit, ButtonConfirm, ButtonDeleteLabel, ButtonCancelLabel, ButtonCompletion, ButtonUpdateOrder, ButtonOutPut, ButtonSendMail  } from "02CommonUiParts/ButtonParts/ButtonBase";

/* ========================== */
/* ========= Styles ========= */
/* ========================== */

/* ====== Styled Components ====== */
/* ------アンダーバー ------*/
const SdivTopMargin = styled.div`
    padding-top: 54px;
`
const SdicUnderbartWrapper = styled.div`//アンダーバー
    display:flex;
    align-items: center;
    padding:0px 10px;
    background-color:#F2F2F2;
    border:1px solid #BDBDBD;
    z-index:60;
    position:fixed;
    bottom:0;
    left:0;
    width:100%;
    height:54px;
`;
const SdivButtonGroup = styled.div`//ボタン枠
    /* width:70%; */
    margin: 0 auto;
    display:flex;
    justify-content: center;
    align-items: center;
`;
const SdivButtonGroupB = styled.div`//ボタン枠B
    width:200px;
    justify-content: start;
    display:flex;
    justify-content: ${props => props.float === 'right' ? 'flex-end' : 'flex-start'};
`;

/*==================*/
/*=====  Main  =====*/
/*==================*/
export const Underbar = (props) => {

    /* --------------------------- */
    /* -------- variables -------- */
    /* --------------------------- */
    const { type, onClickLeft, onClickCenter, onClickRight } = props;

    const checkLeftButton = () => {
        let button;
        switch (type) {
            //back:戻る
            case 'back':
                button = <ButtonBack onClick={onClickLeft} />;
                break;
            //next:戻る・次へ
            case 'next':
                button = <ButtonBack onClick={onClickLeft} />;
                break;
            //nextDelete:戻る・次へ・削除
            case 'nextDelete':
                button = <ButtonBack onClick={onClickLeft} />;
                break;
            //completeBack:戻る・完了
            case 'completeBack':
                button = <ButtonBack onClick={onClickLeft} />;
                break;
            //completeBack:戻る・完了(submit)
            case 'completeSubmitBack':
                button = <ButtonBack onClick={onClickLeft} />;
                break;
                //confirmBack:戻る・確認
            case 'confirmBack':
                button = <ButtonBack onClick={onClickLeft} />;
                break;
                //confirmBackDelete:戻る・確認・削除
            case 'confirmBackDelete':
                button = <ButtonBack onClick={onClickLeft} />;
                break;
            //edit:編集
            case 'edit':
                button = '';
                break;
            //edit:編集・削除
            case 'editDelete':
                button = '';
                break;
            //confirmCancel:キャンセル・確認
            case 'confirmCancel':
                button = <ButtonCancelLabel onClick={onClickLeft} />;
                break;
            //confirmCancelDelete:キャンセル・確認・削除
            case 'confirmCancelDelete':
                button = <ButtonCancelLabel onClick={onClickLeft} />;
                break;
            //completeCancelDelete:キャンセル・完了・削除
            case 'completeCancelDelete':
                button = <ButtonCancelLabel onClick={onClickLeft} />;
                break;
            //oderBy:表示準変更
            case 'oderBy':
                button = '';
                break;
            case 'oderByBack':
                button = <ButtonBack onClick={onClickLeft} />;
                break;
            //output:出力
            case 'output':
                button = '';
                break;
            //outputBack:戻る・出力
            case 'outputBack':
                button = <ButtonBack onClick={onClickLeft} />;
                break;
            //backEdit:戻る・編集
            case 'backEdit':
                button = <ButtonBack onClick={onClickLeft} />;
                break;
            //backEditDelete:戻る・編集・削除
            case 'backEditDelete':
                button = <ButtonBack onClick={onClickLeft} />;
                break;
            default:
                button = '';
                break;
        }
        return button;
    }
    const checkCenterButton = () => {
        let button;
        switch (type) {
            //back:戻る
            case 'back':
                button = '';
                break;
            //next:戻る・次へ
            case 'next':
                button = <ButtonConfirm onClick={onClickCenter} />;
                break;
            //nextDelete:戻る・次へ・削除
            case 'nextDelete':
                button = <ButtonConfirm onClick={onClickCenter} />;
                break;
            //completeBack:戻る・完了
            case 'completeBack':
                button = <ButtonCompletion onClick={onClickCenter} />;
                break;
            //completeBack:戻る・完了(submit)
            case 'completeSubmitBack':
                button = <ButtonCompletion onClick={onClickCenter} type={'submit'}/>;
                break;
            //confirmBack:戻る・確認
            case 'confirmBack':
                button = <ButtonConfirm/>;
                break;
            //confirmBackDelete:戻る・確認・削除
            case 'confirmBackDelete':
                button = <ButtonConfirm/>;
                break;
            //edit:編集
            case 'edit':
                button = <ButtonEdit onClick={onClickCenter} />
                break;
            //editDelete:編集・削除
            case 'editDelete':
                button = <ButtonEdit onClick={onClickCenter} />
                break;
            //confirmCancel:キャンセル・確認
            case 'confirmCancel':
                button = <ButtonConfirm />;
                break;
            //confirmCancelDelete:キャンセル・確認・削除
            case 'confirmCancelDelete':
                button = <ButtonConfirm />;
                break;
            //completeCancel:キャンセル・完了
            case 'completeCancel':
                button = <ButtonCompletion />;
                break;
            //confirmCancelDelete:キャンセル・完了・削除
            case 'completeCancelDelete':
                button = <ButtonCompletion/>;
                break;
            //oderBy:表示準変更
            case 'oderBy':
                button = <ButtonUpdateOrder onClick={onClickCenter} />;
                break;
            case 'oderByBack':
                button = <ButtonUpdateOrder onClick={onClickCenter} />;
                break;
            //output:表示準変更
            case 'output':
                button = <ButtonOutPut />;
                break;
            //outputBack:戻る・出力
            case 'outputBack':
                button = <ButtonOutPut />;
                break;
            //mail:送信
            case 'mail':
                button = <ButtonSendMail />;
                break;
            //backEdit:戻る・編集
            case 'backEdit':
                button = <ButtonEdit onClick={onClickCenter} />;
                break;
            //backEditDelete:戻る・編集・削除
            case 'backEditDelete':
                button = <ButtonEdit onClick={onClickCenter} />;
                break;
            default:
                button = '';
                break;
        }
        return button;
    }
    const checkRightButton = () => {
        let button;
        switch (type) {
            //back:戻る
            case 'back':
                button = '';
                break;
            //next:戻る・次へ
            case 'next':
                button = '';
                break;
            //nextDelete:戻る・次へ・削除
            case 'nextDelete':
                button = <ButtonDeleteLabel onClick={onClickRight} />;
                break;
            //completeBack:戻る・完了
            case 'completeBack':
                button = '';
                break;
            //confirmBack:戻る・完了
            case 'confirmBack':
                button = '';
                break;
            //confirmBackDelete:戻る・確認・削除
            case 'confirmBackDelete':
                button = <ButtonDeleteLabel onClick={onClickRight} />;
                break;
            //edit:編集
            case 'edit':
                button = '';
                break;
            //editDelete:編集・削除
            case 'editDelete':
                button =  <ButtonDeleteLabel onClick={onClickRight}/>;
                break;
            //confirmCancel:キャンセル・確認・削除
            case 'confirmCancelDelete':
                button = <ButtonDeleteLabel onClick={onClickRight}/>;
                break;
            //confirmCancelDelete:キャンセル・完了・削除
            case 'completeCancelDelete':
                button = <ButtonDeleteLabel onClick={onClickRight} />;
                break;
            //oderBy:表示準変更
            case 'oderBy':
                button = '';
                break;
            //output:表示準変更
            case 'output':
                button = '';
                break;
            //backEdit:戻る・編集
            case 'backEdit':
                button = '';
                break;
            //backEditDelete:戻る・編集・削除
            case 'backEditDelete':
                button = <ButtonDeleteLabel onClick={onClickRight}/>;
                break;
            default:
                button = '';
                break;
        }
        return button;
    }

    /* ========================== */
    /* ====== Start Render ====== */
    /* ========================== */
    return (
        <SdivTopMargin>
            <SdicUnderbartWrapper>
                <SdivButtonGroupB float='left'>
                    {checkLeftButton()}
                </SdivButtonGroupB>
                <SdivButtonGroup>
                    <div style={{ margin: '10px' }}>
                        {checkCenterButton()}
                    </div>
                </SdivButtonGroup>
                <SdivButtonGroupB float='right'>
                    <div style={{ marginRight: '20px' }}>
                        {checkRightButton()}
                    </div>
                </SdivButtonGroupB>
            </SdicUnderbartWrapper>
        </SdivTopMargin>
    );
}
